import React from "react";
import BondRiderForm from "./components/BondRiderForm";
import { RIDER_BOND_KIND } from "./riderPageConfig";

export default function TrusteeRider() {
  return <BondRiderForm bondKind={RIDER_BOND_KIND.trustee} />;
}
